import { css } from '@emotion/react';

import { Theme } from '@myrealtrip/web-ui';

import {
  DESKTOP_PRIMARY_CONTAINER_WIDTH,
  DESKTOP_SECONDARY_CONTAINER_WIDTH,
} from '~constants/common';

export const searchStyle = () => css`
  html {
    @media (min-width: ${DESKTOP_PRIMARY_CONTAINER_WIDTH}px) {
      background-color: transparent;
    }
  }
`;

export const searchDetailStyle = (theme: Theme) => css`
  html {
    @media (min-width: ${DESKTOP_SECONDARY_CONTAINER_WIDTH}px) {
      background-color: ${theme.colors.gray.s80};
    }
  }
`;
